import { toast } from 'sonner';

// Re-export from dedicated module for backward compatibility
export { extractErrorMessage, extractErrorContext } from './error';
export type { ErrorContext } from './error';

interface ToastOptions {
  id?: string;
  dismissId?: string;
  icon?: React.ReactNode;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

// Toast utility functions using Sonner's built-in styling
export const showToast = {
  success: (message: string, description?: string, options?: ToastOptions) => {
    if (options?.dismissId) toast.dismiss(options.dismissId);
    toast.success(message, { description, duration: options?.duration ?? 3000, id: options?.id, icon: options?.icon, action: options?.action });
  },

  error: (message: string, description?: string, options?: ToastOptions) => {
    if (options?.dismissId) toast.dismiss(options.dismissId);
    toast.error(message, { description, duration: options?.duration ?? 5000, id: options?.id, icon: options?.icon, action: options?.action });
  },

  info: (message: string, description?: string, options?: ToastOptions) => {
    if (options?.dismissId) toast.dismiss(options.dismissId);
    toast.info(message, { description, duration: options?.duration ?? 4000, id: options?.id, icon: options?.icon, action: options?.action });
  },

  warning: (message: string, description?: string, options?: ToastOptions) => {
    if (options?.dismissId) toast.dismiss(options.dismissId);
    toast.warning(message, { description, duration: options?.duration ?? 4000, id: options?.id, icon: options?.icon, action: options?.action });
  },

  promise: <T,>(
    promise: Promise<T>,
    msgs: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((err: unknown) => string);
    }
  ) => {
    return toast.promise(promise, msgs);
  },
};

// Dismiss a specific toast by its ID (used for in-progress indicators)
export const dismissToast = (id: string) => toast.dismiss(id);